import script from "./CompartmentGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompartmentGrid.vue?vue&type=script&setup=true&lang=ts"

import "./CompartmentGrid.vue?vue&type=style&index=0&id=65d4ab6d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d4ab6d"]])

export default __exports__